import React, { ReactNode } from 'react';

import { FormGroup, Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import styles from './guarantorPerson.module.css';
import messages from './PersonalInformation.messages';
import { renderPhones } from './renderHelpers/renderPhones';
import { Person as TPerson } from './types/PersonalInformation.types';
import DateOfBirth from '../../components/DateOfBirth';
import FormField from '../../components/FormField';
import PrivacyPolicyAgreement from '../../components/PrivacyPolicyAgreement';
import PrivacyPolicyAgreementDE from '../../components/PrivacyPolicyAgreementDE';
import HouseNumberQuestion from '../../containers/PersonalInformationDE/HouseNumberQuestion';
import PostcodeQuestion from '../../containers/PersonalInformationDE/PostcodeQuestion';
import StreetLineOneQuestion from '../../containers/PersonalInformationDE/StreetLineOneQuestion';
import StreetLineTwoQuestion from '../../containers/PersonalInformationDE/StreetLineTwoQuestion';
import TownQuestion from '../../containers/PersonalInformationDE/TownQuestion';
import { getCountryCode } from '../../lendingAPI/lendingAPISelector';
import { RootState } from '../../reducers';

const mapStateToProps = (state: RootState) => ({
    countryCode: getCountryCode(state)
});

type GuarantorPersonProps = {
    person: TPerson;
    onMonthSelect: (month: string) => void;
    isInIndicativeOfferFlow: boolean;
    renderAddresses: (person: TPerson) => ReactNode;
    countryCode: 'uk' | 'de';
};

const GuarantorPerson = ({
    person,
    onMonthSelect,
    renderAddresses,
    countryCode
}: GuarantorPersonProps) => {
    const { privacy_policy_agreement_date } = person;

    const onTick = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { privacy_policy_agreement_date } = person;

        const date = new Date().toISOString();
        const checked = e.target.checked;
        if (checked) {
            privacy_policy_agreement_date?.onChange?.(date);
            return;
        }
        privacy_policy_agreement_date?.onChange?.(null);
    };

    const renderCountryAddress = () => {
        const currentAddress = person.addresses[0];
        if (countryCode === 'de') {
            return (
                <>
                    <FormGroup>
                        <FormField.Header
                            message={
                                <FormattedMessage
                                    {...messages.personalAddress}
                                />
                            }
                        />
                        <StreetLineOneQuestion
                            field={currentAddress.street_line_1}
                        />
                        <HouseNumberQuestion
                            field={currentAddress.house_number}
                        />
                    </FormGroup>
                    <FormGroup>
                        <StreetLineTwoQuestion
                            field={currentAddress.street_line_2}
                        />
                        <PostcodeQuestion field={currentAddress.postcode} />
                    </FormGroup>
                    <FormGroup>
                        <TownQuestion field={currentAddress.town} />
                    </FormGroup>
                </>
            );
        }
        return renderAddresses(person);
    };
    const renderPrivacyPolicy = () => {
        if (countryCode === 'de') {
            return (
                <PrivacyPolicyAgreementDE
                    field={privacy_policy_agreement_date}
                    onTick={onTick}
                />
            );
        }

        return (
            <PrivacyPolicyAgreement
                field={privacy_policy_agreement_date}
                onTick={onTick}
            />
        );
    };

    return (
        <div data-testid="guarantor-person-form">
            <FormGroup className={styles.formGroup}>
                <FormField
                    wrapperClassName="fs-exclude"
                    label={<FormattedMessage {...messages.firstName} />}
                    field={person.first_name}
                    wrapperGrid={{ xs: 6, sm: 6 }}>
                    <FormField.Input />
                </FormField>
                <FormField
                    wrapperClassName="fs-exclude"
                    field={person.last_name}
                    label={<FormattedMessage {...messages.lastName} />}
                    wrapperGrid={{ xs: 6, sm: 6 }}>
                    <FormField.Input />
                </FormField>
            </FormGroup>

            <FormGroup className={styles.formGroup}>
                <Col xs={12} sm={12}>
                    {renderCountryAddress()}
                </Col>
            </FormGroup>
            <FormGroup className={styles.formGroup}>
                <DateOfBirth
                    // @ts-expect-error
                    dob={person.date_of_birth}
                    handleMonthSelectChange={onMonthSelect}
                />
                <FormField
                    wrapperClassName="fs-exclude"
                    label={<FormattedMessage {...messages.emailAddress} />}
                    field={person.email}>
                    <FormField.Input className="xs-push" />
                </FormField>
                {renderPhones(person.phone)}
            </FormGroup>
            {renderPrivacyPolicy()}
        </div>
    );
};

export default connect(mapStateToProps)(GuarantorPerson);
